import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslate } from "src/locales";

type LegendItem = {
  color: string;
  labelKey: string;
};

const ColorsHeader: React.FC = () => {
  const { t } = useTranslate();

  const items: LegendItem[] = [
    { color: "#FFFFFF", labelKey: "menus.stock-legend-yr-drug" },
    { color: "#800000", labelKey: "menus.stock-legend-n-drug" },
    { color: "#CAB468", labelKey: "menus.stock-legend-min-value" },
    { color: "#977DAC", labelKey: "menus.stock-legend-max-value" },
    { color: "#DF8200", labelKey: "menus.stock-legend-critical-value" },
    { color: "#800080", labelKey: "menus.stock-legend-range-narrow" },
    { color: "#008000", labelKey: "menus.stock-legend-p-drug" },
    { color: "#FF80FF", labelKey: "menus.stock-legend-s-drug" },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: 56,
        position: "relative",
        boxShadow: "0px 4px 4px rgba(120, 120, 120, 0.25)",
        borderRadius: "20px",
        bgcolor: "#fff",
        overflow: "hidden",
        flexShrink: 0,
        fontFamily: "Poppins, sans-serif",
        fontSize: 11,
        color: "#000",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 13,
          left: 13,
          display: "flex",
          alignItems: "center",
          gap: "14px",
          whiteSpace: "nowrap",
        }}
      >
        {items.map((item) => (
          <Box key={item.labelKey} sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Box
              sx={{
                width: 22,
                height: 22,
                borderRadius: "4px",
                bgcolor: item.color,
                border: "1px solid #000",
                boxSizing: "border-box",
                flexShrink: 0,
              }}
            />
            <Box
              sx={{
                borderRadius: "4px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                padding: "4px 10px 4px 0px",
                boxSizing: "border-box",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <Typography
                  sx={{
                    fontSize: 11,
                    lineHeight: "22px",
                    textTransform: "capitalize",
                    fontFamily: "Poppins, sans-serif",
                    color: "#000",
                  }}
                >
                  {t(item.labelKey)}
                </Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ColorsHeader;


